import { render } from "./ImageCarouselModal.vue?vue&type=template&id=44ba2666&lang=html"
import script from "./ImageCarouselModal.vue?vue&type=script&lang=js"
export * from "./ImageCarouselModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/sephendevos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__